<template lang="pug">
.card.shadow.mb-4
  .card-header.py-3
    h3.m-0.font-weight-bold.text-primary(style="padding-right:40px") Import Orders
    i.nav-item.fas.fa-fw.fa-times.closeModal.pointer(@click="closeModal()")
  .card-body
    .col-12.orderImportWrap
      .row
        .col-12
          p Bulk Order Import
          p.error(v-if="shopifyChannels.length < 1") We are sorry.  <br>We currently only support imports from Shopify.<br>  Please add a Shopify channel to continue.
          transition(name="fade")
            p.loading(v-if="multiLoading") Loading
      .row  
        .col-12(v-if="shopifyChannels.length > 0")        
          transition(name="fade")
            select.col-12( v-model="multiChannel")
              option( value="" disabled ) Select Platform           
              option(value="shopify") Shopify            
      .row  
        .col-12
          transition(name="fade")
            select.col-12(v-show="multiChannel" v-model="multiStore")
              option( value="" disabled ) Select Store
              option(v-for="theStore in computedStores") {{theStore.store}}              
      .row  
        .col-12.text-right
          button.btn.btn-primary.text-right(v-show="multiStore" v-on:click="importOrders()")
            i.fas.fa-fw.fa-file-import
            | Import
      hr
      .row
        .col-12
          p Single Order Import
          p.loading(v-if="singleLoading") Loading
      .row
        .col-12
          transition(name="fade")
            select.col-12(v-if="shopifyChannels.length > 0" v-model="singleChannel")
              option( value="" disabled ) Select Platform          
              option(value="shopify") Shopify      
      .row
        transition(name="fade")
          .col-12          
            select.col-12(v-show="singleChannel" v-model="singleStore")
              option( value="" disabled ) Select Store              
              option(v-for="theStore in computedStore") {{theStore.store}} 
        transition(name="fade")     
          .col-12(v-show="singleStore.length > 0")
            p Enter Order Number
            input(v-model="orderName")
      .row
        .col-12.text-right
          transition(name="fade")
            button.btn.btn-primary.text-right(v-show="singleStore" v-on:click="importOrder()")
              i.fas.fa-fw.fa-file-import
              | Import

        
      
</template>

<script>
import { mapState } from "vuex";

export default {
  name: 'OrderImport',
  components:{

  },
  props: {    

  },
  
  data:function(){
    return{
      singleChannel:"",
      singleStore:"",
      singleLoading:null,
      orderName:null,

      multiChannel:"",
      multiStore:"",
      multiLoading:false,
      
      theChannel:null,
      
    }
  },
  computed:{ 
    ...mapState(['shopifyChannels','apiChannels', 'amazonChannels']),
    computedStores(){
      // if(this.singleChannel == 'amazon') return this.amazonChannels
      if(this.multiChannel == 'shopify') return this.shopifyChannels
      else return null
    },
    computedStore(){
      if(this.singleChannel == 'shopify') return this.shopifyChannels
      else return null
    }    
  },
  watch:{
       
  },
  methods:{   
    async channelImport(index){
      this.channels[index].syncing = true;
      setTimeout(()=>{ 
        this.$router.push({path:`/dashboard/orders`})
        this.channels[index].syncing = false
        }, 3000);
    },
    async importOrder(){
      var bodyFormData = new FormData()
      bodyFormData.append('storeUrl', this.singleStore)
      bodyFormData.append('orderName', this.orderName)
      this.singleLoading = true;
      var order = await this.axios.post(`/rp/server/order/lookup`,bodyFormData)
      if(order.data.success){
        this.singleLoading = false;
        this.flash(order.data.success.message,'success')
        this.$emit('init');
        this.$emit('closeOrder');
      }

    },
    closeModal(){
      this.$emit('closeOrder');

    },
    async importOrders(){
      var bodyFormData = new FormData()
      bodyFormData.append('storeUrl', this.multiStore)
      this.flash('Importing Orders...','success')
      this.multiLoading = true;
      var orders = await this.axios.post(`/rp/server/order/sync/incoming`, bodyFormData)
      if(orders.data.success){
        this.multiLoading = false;
        this.flash(orders.data.success.message,'success')
        this.$emit('init')
        this.$emit('closeOrder')
      }
    }
  },
  async mounted(){
    document.onkeydown = evt => {
        evt = evt || window.event;
        if (evt.keyCode == 27) {
          this.$emit("closeOrder");
        }
      };

  }
}
</script>

<style scoped lang="scss">
p{
  margin:20px 0 5px 0;
}
.closeModal{
  position:absolute;
  right:20px;
  top:20px;
}
 .loading {
    font-size: 16px;
    color:green;
  }
  // .orderImportWrap{
  //   min-width:500px;
  // }
  .row{
    margin:15px 0;
  }
  .loading:after {
    overflow: hidden;
    display: inline-block;
    vertical-align: bottom;
    -webkit-animation: ellipsis steps(4,end) 900ms infinite;      
    animation: ellipsis steps(4,end) 900ms infinite;
    content: "\2026";
    width: 0px;
  }
  @keyframes ellipsis {
    to {
      width: 1.25em;    
    }
  }
  @-webkit-keyframes ellipsis {
    to {
      width: 1.25em;    
    }
  }
</style>
